import { createStore } from 'vuex'

export default createStore({
  state: {
    appName: 'Admin',
    apiUrl: `https://${process.env.VUE_APP_API_URL}`,
    defaultPerPage: 50
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
